var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstTimeExperienceAccountSummarySmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "119px",
    viewBox: "0 0 120 119",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "first_time_experience-account_summary_small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 -0.00167545361 69.0199509 -0.00167545361 69.0199509 53.6844376 0 53.6844376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0294729,1.75610184 C18.2482524,2.61748903 8.82656339,15.6630378 0.649537125,24.2769096 L0.649537125,24.2769096 C-3.14396373,28.3731343 10.8346873,53.2033363 12.9941432,53.6584723 L12.9941432,53.6584723 C15.1535991,54.1119227 17.9914982,48.5171203 25.5767995,48.0788411 L25.5767995,48.0788411 C33.1587002,47.6405619 40.7099943,43.561194 45.2669564,40.5623529 L45.2669564,40.5623529 C49.822218,37.5601405 59.9903646,34.7618964 64.7530701,33.4807726 L64.7530701,33.4807726 C65.7086718,33.2481475 66.5605517,32.7053556 67.1726809,31.9434241 L67.1726809,31.9434241 C68.6945022,30.0369096 68.3731343,27.2706936 66.4517287,25.7603161 L66.4517287,25.7603161 C65.3277914,25.0101844 58.7286983,25.7013169 52.4611751,26.3907638 L52.4611751,26.3907638 C47.9127149,26.8930992 43.5393916,27.3937489 41.5584735,27.3448639 L41.5584735,27.3448639 C36.8484791,27.2268657 29.8617041,27.2437226 28.3483847,24.2431958 L28.3483847,24.2431958 C26.8333648,21.242669 30.7271869,17.3824407 32.6825997,16.9610184 L32.6825997,16.9610184 C35.3844701,16.2125724 38.1339505,15.6512379 40.9140374,15.2753292 L40.9140374,15.2753292 C41.5584735,15.4944688 48.4619309,19.3546971 48.4619309,19.3546971 L48.4619309,19.3546971 L69.0209711,3.62721686 L55.4180994,0.255838455 C54.6886454,0.0754697103 53.1328169,-0.00207199298 51.0770829,-0.00207199298 L51.0770829,-0.00207199298 C43.3591536,-0.000386303775 28.5932363,1.0767691 24.0294729,1.75610184",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDAS/welcome-val-prop/LG",
    transform: "translate(-98.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CC_onboarding_lowAPR"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CC_onboarding_lowAPR-small",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cc",
    transform: "translate(0.000000, 24.074627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1259021,34.4532959 L75.282713,1.59921335 C77.0034763,0.289432836 79.4689968,0.611399473 80.7884753,2.31731694 C80.7918761,2.32068832 80.7952768,2.32574539 80.8003779,2.32911677 L102.340525,30.1396172 L52.9535991,67.7355435 L31.4134517,39.925043 C30.083771,38.2258683 30.3966371,35.7799333 32.1122993,34.46341 C32.1174003,34.4600386 32.1208011,34.4566673 32.1259021,34.4532959",
    id: "Fill-4",
    fill: "#FF9880"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFB7A9",
    points: "43.7087474 48.5889798 79.635632 21.2403582 82.3085963 24.6892783 46.3800113 52.0395856"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFB7A9",
    points: "47.9438315 53.9275575 76.4741545 32.0877682 79.1522199 35.5232028 50.6201965 57.3646778"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#CE4963",
    points: "71.1477801 10.2709043 77.5819384 5.37397717 81.2377102 10.0939069 74.8035519 14.9908341"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 2.685689)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.648516909,24.2765724 C8.82724353,15.6627006 18.2472322,2.6154662 24.0284527,1.75576471 C29.8096732,0.896063213 51.9483469,-0.604200176 55.4170792,0.255501317 L69.0199509,3.62687972 L48.462611,19.35436 C48.462611,19.35436 41.5591536,15.4941317 40.9130172,15.2749921 C38.1346306,15.6492151 35.3851502,16.2122353 32.6832798,16.9606813 C30.727867,17.3821036 26.834045,21.2423319 28.3473644,24.2428586 C29.8606839,27.2433854 36.8491593,27.2265285 41.5591536,27.3445268 C46.2691479,27.462525 64.5139996,24.4619982 66.4524088,25.7599789 C68.3738145,27.2703565 68.6951823,30.0365724 67.173361,31.9414012 C66.5595315,32.7050184 65.709352,33.2478104 64.7520499,33.4804355 C59.9910448,34.7615593 49.8228982,37.5598033 45.2659361,40.5620158 C40.7089741,43.5608569 33.1593803,47.6402248 25.5757793,48.0801896 C17.9921783,48.5167831 15.1525789,54.1132713 12.993123,53.6581352 C10.8336671,53.2046848 -3.14328358,28.3727972 0.648516909,24.2765724",
    id: "Fill-12",
    fill: "#AA8C77",
    mask: "url(#mask-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hand",
    transform: "translate(0.000000, 26.760316)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5302475,17.0449658 C38.908294,13.5303038 45.7879463,10.9967129 52.9345551,9.52679192 C55.3881731,9.41553644 57.841791,9.74087445 60.1780843,10.4876348 L48.5306254,19.35436 L40.7089741,15.2581352 L31.2039675,17.7698121",
    id: "Fill-16",
    fill: "#7F6353",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "details",
    transform: "translate(21.107123, 0.665847)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 77.4003401,
    y1: 34.4079017,
    x2: 87.1093898,
    y2: 26.9908692,
    id: "Stroke-3",
    stroke: "#FFCD41",
    strokeWidth: 3.14566408,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.28093709,
    y1: 114.955189,
    x2: 97.1018326,
    y2: 40.423705,
    id: "Stroke-19",
    stroke: "#FFCD41",
    strokeWidth: 3.14566408,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.8331759,
    y1: 114.955189,
    x2: 37.5495938,
    y2: 109.795294,
    id: "Stroke-21",
    stroke: "#FFCD41",
    strokeWidth: 3.14566408,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.2627999,
    y1: 105.430371,
    x2: 80.3646325,
    y2: 77.0602212,
    id: "Stroke-23",
    stroke: "#FFCD41",
    strokeWidth: 3.14566408,
    strokeLinecap: "round",
    strokeDasharray: "18.02380523681641,7.209521484375"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.2047421,
    y1: 74.8689939,
    x2: 89.9381636,
    y2: 69.7276418,
    id: "Stroke-25",
    stroke: "#FFCD41",
    strokeWidth: 3.14566408,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.2311921,
    y1: 0.125197542,
    x2: 90.2311921,
    y2: 9.36277436,
    id: "Stroke-27",
    stroke: "#FFCD41",
    strokeWidth: 2.04043076,
    strokeLinecap: "round",
    strokeDasharray: "24.48516845703125,6.121292114257812"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.8906858,
    y1: 4.74432309,
    x2: 85.5897223,
    y2: 4.74432309,
    id: "Stroke-29",
    stroke: "#FFCD41",
    strokeWidth: 2.04043076,
    strokeLinecap: "round",
    strokeDasharray: "24.48516845703125,6.121292114257812"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.224693,
    y1: 102.21475,
    x2: 89.224693,
    y2: 111.450641,
    id: "Stroke-31",
    stroke: "#FFCD41",
    strokeWidth: 2.04043076,
    strokeLinecap: "round",
    strokeDasharray: "24.48516845703125,6.121292114257812"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.8824863,
    y1: 106.83219,
    x2: 84.5645192,
    y2: 106.83219,
    id: "Stroke-33",
    stroke: "#FFCD41",
    strokeWidth: 2.04043076,
    strokeLinecap: "round",
    strokeDasharray: "24.48516845703125,6.121292114257812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3107878,62.8117647 C96.299933,62.8117647 97.1018326,63.6136643 97.1018326,64.6028095 C97.1018326,65.5919547 96.299933,66.3938543 95.3107878,66.3938543 C94.3216426,66.3938543 93.5197431,65.5919547 93.5197431,64.6028095 C93.5197431,63.6136643 94.3216426,62.8117647 95.3107878,62.8117647 Z",
    id: "Stroke-41",
    fill: "#FFCD41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6092953,9.08042142 C76.5984405,9.08042142 77.4003401,9.88232102 77.4003401,10.8714662 C77.4003401,11.8606114 76.5984405,12.662511 75.6092953,12.662511 C74.6201501,12.662511 73.8182505,11.8606114 73.8182505,10.8714662 C73.8182505,9.88232102 74.6201501,9.08042142 75.6092953,9.08042142 Z",
    id: "Stroke-41-Copy",
    fill: "#FFCD41"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstTimeExperienceAccountSummarySmall);
export default __webpack_public_path__ + "static/media/first_time_experience-account_summary_small.17656649e0ae7208e90fda421cef4290.svg";
export { ForwardRef as ReactComponent };